import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';


import moment from 'moment';
import { AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { ColorCMM, ColorGSM, ColorNGR, ColorNGV } from '../../FixColor';
am4core.addLicense("CH208466903");


const StackedBarChart = (props) => {
    const { sBA, data,exportImg } = props

    useEffect(() => {
        if (data != null) {
            onRenderGraph(data);
        }

    }, [data])

    const onRenderGraph = async (detail) => {

        let chart = am4core.create("StackedBarChart", am4charts.XYChart);

        var colorSet = new am4core.ColorSet();
        colorSet.list = [ColorCMM(), ColorGSM(), ColorNGR(), ColorNGV()].map(color => {
            return am4core.color(color);
        });
        chart.colors = colorSet;

        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";

        // Create axes
        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "VOC";
        categoryAxis.renderer.grid.template.opacity = 0;
        categoryAxis.title.text = "Type Of VOC";

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.renderer.grid.template.opacity = 1;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
        valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.line.strokeOpacity = 0.5;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.minGridDistance = 40;
        valueAxis.title.text = "จำนวนใบงาน";

        //top Y
        // let topContainer = chart.chartContainer.createChild(am4core.Container);
        // topContainer.layout = "absolute";
        // topContainer.toBack();
        // topContainer.paddingBottom = 15;
        // topContainer.width = am4core.percent(100);

        // let axisTitle = topContainer.createChild(am4core.Label);
        // axisTitle.text = "Type Of VOC";
        // axisTitle.align = "left";

        //series

        chart.data = detail.data;

        // Create series

        detail.BA.forEach(type => {
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueX = type;
            series.dataFields.categoryY = "VOC";
            series.stacked = true;
            series.name = type;
            series.columns.template.tooltipText = type + ": [bold]{valueX}[/]";

            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.locationX = 0.5;
            labelBullet.label.text = "{valueX}";
            labelBullet.label.fontSize = "8pt";
            // labelBullet.label.fill = am4core.color("#fff");
        });
        
        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let obj = {
                    id: 1,
                    nOrder : 1,
                    sDesc: "Div 4  bar",
                    sName : "",
                    idDiv : 4,
                    imgBase64: data
                }
                props.exportImg && props.exportImg(obj);
            });
        }, 2000);
    }

    return (
        <>
            <div className='div-border'>
                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                    <Grid item xs={12}>
                        <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <div id='SatisFactiondiv4' style={{ padding: '8px' }}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                                <Grid item xs={12}>
                                    <div id="StackedBarChart" style={{ width: "100%", height: "400px" }}></div>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default StackedBarChart